import React, { Fragment, useRef, useState } from "react"
import { Link } from "react-router-dom"
import {
    Button, Card, CardBody, CardSubtitle, CardTitle, Col, Container, Label, Row
} from "reactstrap"
import { accessRole } from "../../../../helpers/access_role"
import Select from "../../../../helpers/ui/CustomSelect"
import TableActiveComponent from './Components/TablePrimaryComponent'

const statusPengajuan = [
    { value: '', label: 'Semua Status' },
    { value: 0, label: 'Menunggu Persetujuan Admin' },
    { value: 1, label: 'Pengajuan Disetujui' },
    { value: 2, label: 'Pengajuan Ditolak' },
]

const IndexView = (props) => {

    const [activeTab, setactiveTab] = useState("1")    
    const [status, setStatus] = useState(null)
    const [filter, setFilter] = useState()
    const activeRef = useRef();
    const inactiveRef = useRef();

    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'))
    const peg_detail = !accessRole('approve') ? (userdata != null ? userdata : "") 
    : (employeeSeleted != null ? employeeSeleted : "")

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    // const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    const handleButtonSearch = () => {
        // if (status) {
            setFilter({
                'status': status
            })
            setTimeout(() => {
                reloadActiveRef()
            }, 300);
        // }
    }

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <Card>
                            <CardBody>
                                <div className="float-end">
                                    <Button color="primary" onClick={()=>handleButtonSearch()}>Load Data</Button>
                                    &nbsp;&nbsp;
                                    { accessRole('create') &&
                                    <Link to="?createadmin">
                                        <Button color="primary" 
                                        // onClick={()=>reloadActiveRef()}
                                        >Tambah Pengajuan Angka Kredit</Button>
                                    </Link>
                                    }
                                </div>
                                <CardTitle>Daftar Pengajuan Angka Kredit</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Kelola Daftar Pengajuan Angka Kredit
                                </CardSubtitle>
                                <hr />
                                <Row className="mb-3">
                                    <Label className="col-md-3 col-form-label">
                                        Status Pengajuan Angka Kredit
                                    </Label>
                                    <Col md="3">
                                        <Select options={statusPengajuan} isAvForm={false} isClearable={true} 
                                        value={statusPengajuan.find(o => o.value === status)}
                                        onChange={opt => setStatus(opt ? opt.value : '')}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md="3"></Col>
                                    <Col md="10">
                                        <Button
                                            color="primary"
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                    </Col>
                                </Row>
                                <hr />
                                <TableActiveComponent ref={activeRef} 
                                // handleInactiveSuccess={reloadInactiveRef}
                                 filter={filter}/>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView